import React, { Component } from 'react';
// utils
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { closeVideo } from '../../redux/reducers/videoPlayer.js';
// components
import ReactPlayer from 'react-player';
// styles
import classnames from 'classnames/bind';
import styles from './VideoPlayer.mod.css';

const cn = classnames.bind(styles);

export class VideoPlayer extends Component {
  componentWillReceiveProps({ isOpen }) {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }

  listenKeyboard = event => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.props.closeVideo();
    }
  };

  listenPopstate = () => {
    this.props.closeVideo();
  };

  componentDidMount() {
    window.addEventListener('keydown', this.listenKeyboard, true);
    window.addEventListener('popstate', this.listenPopstate, true);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.listenKeyboard, true);
    window.removeEventListener('popstate', this.listenPopstate, true);
  }

  render() {
    const { url, title, isOpen, closeVideo, ...otherProps } = this.props;
    return isOpen ? (
      <div className={cn(styles.playWrapper)} onClick={closeVideo}>
        <h2 className={styles.title} onClick={e => e.stopPropagation()}>
          {title}
        </h2>
        <ReactPlayer
          url={url}
          controls
          playing
          width="100%"
          height="56vw"
          style={{
            maxWidth: '960px',
            maxHeight: '540px'
          }}
          {...otherProps}
        />
      </div>
    ) : null;
  }
}

VideoPlayer.propTypes = {
  url: T.string,
  title: T.string,
  isOpen: T.bool
};

export default connect(
  state => ({
    url: state.videoPlayer.url,
    title: state.videoPlayer.title,
    isOpen: state.videoPlayer.isOpen
  }),
  { closeVideo }
)(VideoPlayer);



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.jsx